<div class="container" style="background-color: #ffffff; padding-bottom: 6rem;">
	<div class="rk-ui-notification" *ngIf="successalert">
		<span id="notificationMessageText">{{successMessage}}</span>
		<a class="close rk-linknotification" (click)="successalert=false">×</a>
	</div>
	<div class="rk-ui-notification err" *ngIf="erroralert">
		<span id="notificationMessageText">{{errorMessage}}</span>
		<a class="close rk-linknotification" (click)="erroralert=false">×</a>
	</div>
<div class="container-fluid">
<div class="row pt-4">
	<button (click)="gobrowse()" class="back-btn">Back</button>
</div>
  <div class="row justify-content-center pt-4">
    <h2>{{fetchData.portfolio.space}} - {{fetchData.portfolio.id}} ({{fetchData.portfolio.preset_number}})</h2>
    </div>
</div>
<div class="container-fluid backcolor">
	<div class="row justify-content-center">
		<div class="col-md-10">
		<div class="row">	
		<div class="col-sm-3 col-md-6 col-lg-4">
			<img src={{fetchData?.portfolio.attachment_file}} onerror="src='../../../assets/img/default-apartment.png'" alt="" class="image w-100">

		</div>
		<div class="col-sm-6 col-md-6 col-lg-8 mt-3">
		<p>
				{{transform(fetchData.portfolio.description)}}
		</p>	
		<p class="text-capitalize">
			<span class="font-weight-bold">
				Life Stage: 
			</span>
			<span class="">
				{{transform(fetchData.portfolio.lifestage)}}
			</span>
		</p>

		<p class="text-capitalize">
				<span class="font-weight-bold">
					Theme: 
				</span>
				<span>
					{{transform(fetchData.portfolio.theme)}}
				</span>
			</p>

		<p class="text-capitalize">
				<span class="font-weight-bold">
					Budget: 
				</span>
				<span>
					Price:</span>
				<span >{{fetchData.portfolio.price | currency: 'INR':true}}
				</span>
			</p>

      
      <p class="text-capitalize">
				<span class="font-weight-bold">
					Preset Number: 
				</span>
				<span>
					{{fetchData.portfolio.preset_number}}
				</span>
			</p>
		</div>
		</div>
		</div>
	</div>
</div>
<div class="container-fluid">
	<div class="row justify-content-center">
		<div class="col-md-10 mt50px">
		  <div class="d-flex">
        <div class="titleTriangle"
      >INCLUSION OF THE DESIGN
  </div>
      <span class="arrow-down"></span>
    <img
      src="../assets/img/Fill-117.svg"
      class="smallLogoIcon zI1"
      alt="vwuy"
    />
      </div>
		</div>
	  </div>
</div>
<div class="container-fluid mt-4">
	<div class="row justify-content-center">
		<div class="col-md-10 col-sm-12">
			<div class="row">
				<div class="col-md-12">
				<div class="profile2">
					
									<!-- <img src={{fetchData.portfolio.attachment_file}} onerror="src='../../../assets/img/default-apartment.png'" class="w-100"> -->
									<div
									id="carouselExampleControls"
									class="carousel slide"
									data-ride="carousel"
									*ngIf="fetchData && fetchData.portfolio.contents.length != 0"
								>
									<div class="carousel-inner">
										<div class="carousel-item active">
											<img
												src="{{ fetchData.portfolio.attachment_file }}"
												onerror="src='../../../assets/images/default-apartment.png'"
												class="w-100"
											/>
										</div>
										<ng-container
											*ngFor="let images of fetchData.portfolio.contents"
										>
											<div class="carousel-item">
												<img
													class="d-block w-100"
													[src]="images.attributes.document"
													onerror="src='../../../assets/images/default-apartment.png'"
													class="w-100"
													alt="First slide"
												/>
											</div>
										</ng-container>
									</div>
									<a
										class="carousel-control-prev"
										href="#carouselExampleControls"
										role="button"
										data-slide="prev"
									>
										<span
											class="carousel-control-prev-icon"
											aria-hidden="true"
										></span>
										<span class="sr-only">Previous</span>
									</a>
									<a
										class="carousel-control-next"
										href="#carouselExampleControls"
										role="button"
										data-slide="next"
									>
										<span
											class="carousel-control-next-icon"
											aria-hidden="true"
										></span>
										<span class="sr-only">Next</span>
									</a>
								</div>	
								<div
								*ngIf="fetchData && fetchData.portfolio.contents.length == 0"
							>
								<img
									src="{{ fetchData?.portfolio.attachment_file }}"
									onerror="src='../../../assets/img/default-apartment.png'"
									class="w-100"
								/>
							</div>
					</div>
					</div>
					</div>
		</div>
		
	</div>
</div>

<div class="container-fluid mt-3">
	<div class="row justify-content-center">
		<div class="col-md-10 col-10">
			<!-- <div class="pl-3 pr-3 pl-lg-0 pr-lg-0"> -->
				<div class="row">
				<ng-container *ngFor = "let item of fetchData.portfolio.space_items">
					<!-- <div class="row"> -->
						<div class="col-12 col-md-3 rectangular1">
								<div class="row">
									<div class="col-8">
										<div class="oven text-capitalize"> {{item.item_name}}</div>
										<div style="font-size: 13px;">{{item.description}}
										<p class="include">Include Me:
											<label class="switch">
												<input type="checkbox" value="{{item.id}}" (change) = "getItems($event,item.id,item)" checked>
												<span class="slider round"></span>
											</label>
										</p>
										
									</div>
									</div>
									<div class="col-4">
										<img class="img-fluid" src={{item.image}} onerror="src='../../../assets/img/default-apartment.png'">
									</div>
								</div>
							</div>
				</ng-container>
				</div>
		</div>
	</div>
</div>

<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-md-10 col-12">
      <div class="row justify-content-between">
  <div class="emi-dta-styl">
    <span class="emi-style">
      Price:</span>
      <span class="data-style"> {{fetchData.portfolio.price | currency: 'INR':true}}
    </span>
  </div>
</div>
<div *ngIf="fetchData.portfolio.boq_number" class="row justify-content-between">
  <div class="emi-dta-styl">
    <span class="emi-style">
      Boq Number:</span>
    <a style="cursor: pointer;" (click)="downloadCustomerBoqPdf()"><span class="data-style"> {{fetchData.portfolio.boq_number}}
    </span></a>
  </div>
  </div>
<div *ngIf="fetchData.portfolio.boq_value" class="row justify-content-between">
  <div  class="emi-dta-styl">
    <span class="emi-style">
      Boq Value:</span>
      <span class="data-style"> {{fetchData.portfolio.boq_value}}
    </span>
  </div>
</div>

    </div>
  </div>
  </div>

	</div>

	<div class="loading d-block justify-content-center" *ngIf="loader">
		<div class="spinner-border" style="color: #8d0528;" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>


// WEBPACK FOOTER //
// ./src/app/platform/browse-preset-inclusion/browse-preset-inclusion.component.html